import { useEditIndicators } from '../hooks/useEditIndicators';

export const EditSpecificIndicators = () => {
	const { getComponent } = useEditIndicators({ isGeneralIndicator: false });

	return getComponent();
};
